import script from "./AssetBase.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetBase.vue?vue&type=script&setup=true&lang=js"

import "./AssetBase.vue?vue&type=style&index=0&id=c3418dd2&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3418dd2"]])

export default __exports__